
import React from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';

const Layout = ({ children, onOpenVisualizer, onOpenSearch, isVisualizerOpen, isSearchOpen }) => {
    const location = useLocation();
    const isAdmin = location.pathname.startsWith('/admin');
    const shouldHideNav = isAdmin;

    return (
        <div className="relative">
            {/* NAVBAR */}
            {!shouldHideNav && (
                <div className={isVisualizerOpen || isSearchOpen ? 'hidden' : 'block'}>
                    <Navbar
                        onOpenVisualizer={onOpenVisualizer}
                        onOpenSearch={onOpenSearch}
                    />
                </div>
            )}

            {/* Main Content */}
            <main>
                {children}
            </main>

            {/* FOOTER */}
            {!shouldHideNav && <Footer />}
        </div>
    );
};

export default Layout;
